<template>
    <component
        :is="getComponentForSection"
        :registrationData="registrationData"
        style="display:none;"
    ></component>
</template>

<script>
    import SectionFactory from '../../components/pagesbuilder/sections/SectionFactory'
    import PreviewHtmlSection from "./PreviewHtmlSection";
    import PreviewSimpleSection from "./PreviewSimpleSection";
    import PreviewPageFooterSection from "./footer/PreviewPageFooterSection";
    import PreviewSchoolFooterSection from "./footer/PreviewSchoolFooterSection";
    import PreviewSchoolTopbarSection from "./topbar/PreviewSchoolTopbarSection";
    import PreviewPageTopbarSection from "./topbar/PreviewPageTopbarSection";
    import PreviewCourseOverviewSection from "./PreviewCourseOverviewSection";
    import PreviewBundleOverviewSection from "./PreviewBundleOverviewSection";
    import PreviewSubscriptionOverviewSection from "./PreviewSubscriptionOverviewSection";
    import PreviewThankYouSection from "./PreviewThankYouSection";

    export default {
        name: "PreviewSectionFactory",
        mixins: [SectionFactory],
        data() {
            return {
                envNamePrefix: "Preview"
            }
        },
        components: {
            PreviewSimpleSection,
            PreviewHtmlSection,
            PreviewPageFooterSection,
            PreviewSchoolFooterSection,
            PreviewSchoolTopbarSection,
            PreviewPageTopbarSection,
            PreviewCourseOverviewSection,
            PreviewBundleOverviewSection,
            PreviewSubscriptionOverviewSection,
            PreviewThankYouSection,
          // PreviewSimpleSection: () => import("./PreviewHtmlSection"),
          // PreviewHtmlSection: () => import("./PreviewHtmlSection"),
          // PreviewPageFooterSection: () => import("./footer/PreviewPageFooterSection"),
          // PreviewSchoolFooterSection: () => import("./footer/PreviewSchoolFooterSection"),
          // PreviewSchoolTopbarSection: () => import("./topbar/PreviewSchoolTopbarSection"),
          // PreviewPageTopbarSection: () => import("./topbar/PreviewPageTopbarSection"),
          // PreviewCourseOverviewSection: () => import("./PreviewCourseOverviewSection"),
          // PreviewBundleOverviewSection: () => import("./PreviewBundleOverviewSection"),
          // PreviewSubscriptionOverviewSection: () => import("./PreviewSubscriptionOverviewSection"),
        }
    }
</script>
